import FpsDao from "./FpsDao";
import {
  FineValueReq,
  FineValueRes,
  Fps,
  FpsMedia,
  FineSearchReq,
  FineSearchRes,
  FpsId
} from "../model";
import { FpsApiInterface, MediaApiInterface } from "../swagger";

export class SwaggerFpsDao implements FpsDao {
  private readonly _fpsSwaggerClient: FpsApiInterface;
  private readonly _fpsMediaSwaggerClient: MediaApiInterface;

  public constructor(
    fpsSwaggerClient: FpsApiInterface,
    fpsMediaSwaggerClient: MediaApiInterface
  ) {
    this._fpsSwaggerClient = fpsSwaggerClient;
    this._fpsMediaSwaggerClient = fpsMediaSwaggerClient;
  }

  public async calcFps(
    cityId: string,
    fineValueReq: FineValueReq
  ): Promise<FineValueRes> {
    try {
      const res = await this._fpsSwaggerClient.calcFPS(
        cityId,
        fineValueReq as any
      );

      return res.data as FineValueRes;
    } catch (error) {
      throw error;
    }
  }

  public async saveFps(cityId: string, fps: Fps): Promise<Fps> {
    try {
      const res = await this._fpsSwaggerClient.sendFPS(cityId, fps as any);

      return (res.data as unknown) as Fps;
    } catch (error) {
      throw error;
    }
  }

  public async searchFps(
    cityId: string,
    fineSearchReq: FineSearchReq
  ): Promise<FineSearchRes> {
    try {
      const res = await this._fpsSwaggerClient.searchFPS(
        cityId,
        fineSearchReq as any
      );

      return (res.data as unknown) as FineSearchRes;
    } catch (error) {
      throw error;
    }
  }

  public async saveFpsMedia(cityId: string, fpsMedia: FpsMedia): Promise<void> {
    try {
      await this._fpsMediaSwaggerClient.addPicture(cityId, fpsMedia);
    } catch (error) {
      throw error;
    }
  }

  public async getLastId(
    cityId: string,
    organisationid: string,
    matricule?: string,
    date?: string,
    options?: any
  ): Promise<FpsId> {
    try {
      const res = await this._fpsSwaggerClient.getLastId(
        cityId,
        organisationid,
        matricule,
        date,
        options
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }

  public async getNextId(
    cityId: string,
    organisationid: string,
    matricule?: string,
    date?: string,
    options?: any
  ): Promise<FpsId> {
    try {
      const res = await this._fpsSwaggerClient.getNextId(
        cityId,
        organisationid,
        matricule,
        date,
        options
      );

      return res.data;
    } catch (error) {
      throw error;
    }
  }
}

export default SwaggerFpsDao;
